import type { UserRole } from '@/types/api';

export function canManage(role: UserRole): boolean {
  return role === 'owner' || role === 'manager';
}

export function roleLabel(role: UserRole): string {
  const labels: Record<UserRole, string> = {
    owner: 'Proprietário',
    manager: 'Gerente',
    operator: 'Operador',
  };
  return labels[role];
}
